<template>
  <b-card class="rounded-xl">
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        EDIT IMAGE ORDER
      </h6>
      <EditCategoryDetail />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>

    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">Post</h2>
      </div>
      <div class="md:py-4 lg:py-4">
        <base-button
          type="primary"
          class="flex w-full py-3"
          @click="createPost"
        >
          <feather-icon icon="EditIcon" class="mr-1"></feather-icon>Create Post
        </base-button>
      </div>
      <CreatePostSidebar
        @closeModal="closeModal"
        :PostCreateSidebar="PostCreateSidebar"
      />

      <!-- <base-button outline type="success" class="flex" @click="addBanner">
        <feather-icon icon="PlusIcon" classḍ="mr-1"></feather-icon> Post
      </base-button> -->
    </div>
    <!-- <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class=" cursor-pointer  mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group> -->

    <UsersTable ref="postTable" />
  </b-card>
</template>
<script>
import "../../scss/Index.scss";
import CategoryData from "./components/CategoryData";
import UsersTable from "./components/UsersTable";
import CreatePostSidebar from "./components/CreatePostSidebar.vue";

export default {
  name: "light-table",
  components: {
    UsersTable,
    CreatePostSidebar,
  },
  data() {
    return {
      CategoryData,
      currentPage: 1,
      editModal: false,
      PostCreateSidebar: false,
    };
  },
  methods: {
    createPost() {
      // console.log("HELLOO")
      // this.$store.commit("UI/TOGGLE_POST_CREATE_SIDEBAR", true);
      this.PostCreateSidebar = !this.PostCreateSidebar;
    },
    closeModal() {
      this.PostCreateSidebar = false;

      this.$refs.postTable.dataload();
    },
  },
};
</script>
